var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifConfirmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    fill: "#53D769",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    stroke: "#53D769",
    strokeOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C11.5886 8 8 11.5886 8 16C8 20.4114 11.5886 24 16 24C20.4114 24 24 20.4114 24 16C24 11.5886 20.4114 8 16 8ZM20.0547 14.3047L15.7213 18.6379C15.5913 18.7679 15.4207 18.8334 15.25 18.8334C15.0793 18.8334 14.9087 18.7679 14.7787 18.6379L12.6121 16.4713C12.3513 16.2107 12.3513 15.7893 12.6121 15.5287C12.8727 15.2679 13.2939 15.2679 13.5547 15.5287L15.25 17.224L19.1121 13.3621C19.3727 13.1013 19.7939 13.1013 20.0547 13.3621C20.3153 13.6227 20.3153 14.0439 20.0547 14.3047Z",
    fill: "#53D769"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifConfirmIcon);
export default __webpack_public_path__ + "static/media/notifConfirmIcon.bc013c7ef3ff16137c36bd1bad745c5f.svg";
export { ForwardRef as ReactComponent };